import { render } from "./CameraPausedNotice.vue.js?vue&type=template&id=d6cf26e2!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CameraPausedNotice.vue?vue&type=template&id=d6cf26e2"
import script from "./CameraPausedNotice.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CameraPausedNotice.vue?vue&type=script&lang=js"
export * from "./CameraPausedNotice.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CameraPausedNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/CameraPausedNotice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6cf26e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6cf26e2', __exports__)) {
    api.reload('d6cf26e2', __exports__)
  }
  
  module.hot.accept("./CameraPausedNotice.vue.js?vue&type=template&id=d6cf26e2!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CameraPausedNotice.vue?vue&type=template&id=d6cf26e2", () => {
    api.rerender('d6cf26e2', render)
  })

}


export default __exports__